import { useState } from 'react';

// A "Read more →" link that opens the additional hero paragraphs in a modal,
// keeping the hero clean. Plain-styled (no MUI) to match the public templates.
export default function HeroReadMore({ paragraphs = [], heading = 'About us', linkColor = '#fff', linkStyle = {} }) {
  const [open, setOpen] = useState(false);
  const paras = (paragraphs || []).filter(Boolean);
  if (paras.length === 0) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        style={{
          background: 'none', border: 'none', color: linkColor, fontWeight: 700, cursor: 'pointer',
          padding: 0, textDecoration: 'underline', fontSize: '0.95rem', marginBottom: 28, alignSelf: 'flex-start',
          ...linkStyle,
        }}
      >
        Read more →
      </button>
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: '#fff', color: '#1e293b', borderRadius: 16, maxWidth: 560, width: '100%', maxHeight: '80vh', overflowY: 'auto', padding: '24px 28px 26px', boxShadow: '0 24px 64px rgba(0,0,0,0.32)' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 700 }}>{heading}</h3>
              <button type="button" onClick={() => setOpen(false)}
                style={{ background: 'none', border: 'none', fontSize: '1.6rem', cursor: 'pointer', color: '#64748b', lineHeight: 1 }}>×</button>
            </div>
            {paras.map((p, i) => (
              <p key={i} style={{ lineHeight: 1.75, margin: '0 0 14px', color: '#334155' }}>{p}</p>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
